export { default as base } from './base.json'
export { default as birthdate } from './birthdate.json'
export { default as city } from './city.json'
export { default as company } from './company.json'
export { default as confirmation } from './confirmation.json'
export { default as country } from './country.json'
export { default as nationality } from './nationality.json'
export { default as email } from './email.json'
export { default as error } from './error.json'
export { default as firstName } from './firstName.json'
export { default as flowConfirmation } from './flowConfirmation.json'
export { default as gender } from './gender.json'
export { default as house } from './house.json'
export { default as lastName } from './lastName.json'
export { default as legal } from './legal.json'
export { default as overview } from './overview.json'
export { default as phone } from './phone.json'
export { default as phoneVerification } from './phoneVerification.json'
export { default as postalCode } from './postalCode.json'
export { default as privacy } from './privacy.json'
export { default as screens } from './screens.json'
export { default as street } from './street.json'
export { default as terms } from './terms.json'
export { default as username } from './username.json'
export { default as welcome } from './welcome.json'
export { default as password } from './password.json'
export { default as passwordAnimated } from './passwordAnimated.json'
export { default as currency } from './currency.json'
export { default as devmode } from './devmode.json'
export { default as securityQuestion } from './securityQuestion.json'
export { default as social } from './social.json'
export { default as fullName } from './fullName.json'
export { default as GDPR } from './GDPR.json'
export { default as softGDPR } from './softGDPR.json'
export { default as recaptcha } from './recaptcha.json'
export { default as bonuses } from './bonuses.json'
export { default as bonus } from './bonus.json'
export { default as residence } from './residence.json'
export { default as amount } from './amount.json'
export { default as signature } from './signature.json'
export { default as alert } from './alert.json'
export {default as iban} from './iban.json'
export {default as idin} from './idin.json'
export { default as shortcuts } from './shortcuts.json'
export { default as taxNumber } from './taxNumber.json'



// WEBPACK FOOTER //
// ./src/locales/i18next/en/index.js